var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.safeItem)?_c('div',{staticClass:"pro-item",on:{"click":function($event){_vm.$router.push(
      {
        name: 'product',
        query: {
          id: _vm.safeItem.id
        }
      },
      () => {}
    )}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.safeItem.carousel_list[0]),expression:"safeItem.carousel_list[0]"}],staticClass:"pro-img",attrs:{"alt":_vm.safeItem.name}}),_c('div',{staticClass:"item-content"},[_c('p',{staticClass:"no"},[_vm._v(" No. : "),_c('span',[_vm._v(_vm._s(_vm.safeItem.id))])]),_c('h3',{staticClass:"van-ellipsis"},[_vm._v(_vm._s(_vm.safeItem.name))]),_c('p',{staticClass:"van-multi-ellipsis--l2",domProps:{"innerHTML":_vm._s(_vm.safeItem.bewrite)}}),_c('p',{staticClass:"price"},[_vm._v(" ￥"),_c('span',[_vm._v(_vm._s(_vm.safeItem.starting_price))])])]),(_vm.safeItem.status == 2 && _vm.safeIsShow)?_c('div',{staticClass:"pro-state"},[_vm._v(" "+_vm._s(_vm.safeItem.status_text)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }